export default __webpack_public_path__ + "static/media/training@2x.53667e88.png";